import {
  reqGetCustomerUsers,
  reqSaveUser,
  reqGetActivationLink,
  reqActivateUser,
  reqDeleteUser,
  reqFindCustomerDevice,
} from "@/api/api.js";
import {getName} from "@/utils/setToken";
const state = {
  customerUsersList: {},
  customerUsersInfo: [],
  userId: "",
  activationLink: "",
  customerDeviceFind: [],
};
const mutations = {
  GETCUSTOMERUSERSLIST(state, customerUsersList) {
    state.customerUsersList = customerUsersList;
  },
  GETTCUSTOMERUSERSINFO(state, customerUsersInfo) {
    state.customerUsersInfo = customerUsersInfo;
  },
  GETUSERID(state, userId) {
    state.userId = userId;
  },
  GETACTIVATIONLINK(state, activationLink) {
    state.activationLink = activationLink;
  },
  FINDCUSTOMERDEVICE(state, customerDeviceFind) {
    state.customerDeviceFind = customerDeviceFind;
  },
};
const actions = {
  async getCustomerUsersList({ commit }, params = {}) {
    let result = await reqGetCustomerUsers(params);
    if (result.status === 200) {
      commit("GETCUSTOMERUSERSLIST", result.data);
      commit("GETTCUSTOMERUSERSINFO", result.data.data);
    }
  },
  async saveUser({ commit }, params = {}) {
    let result = await reqSaveUser(params);
    if (result.status === 200) {
      commit("GETUSERID", result.data.id.id);
    }
  },
  async getActivationLink({ commit }, params = {}) {
    let result = await reqGetActivationLink(params);
    if (result.status === 200) {
      commit("GETACTIVATIONLINK", result.data);
    }
  },
  async activateUser({ commit }, params = {}) {
    let result = await reqActivateUser(params);
    if (result.status === 200) {
      return "ok";
    }
  },
  async deleteUser({ commit }, userId) {
    let result = await reqDeleteUser(userId);
    if (result.status === 200) {
      return "ok";
    }
  },
  async findCustomerDevice({ commit }, data) {
    let result = await reqFindCustomerDevice(data);
    if (result.status === 200) {
      commit("FINDCUSTOMERDEVICE", result.data.data);
    }
  },
};
const getters = {
  customerUsersList(state) {
    return state.customerUsersList || {};
  },
  customerUsersInfo(state) {
    for (let i = 0; i < state.customerUsersInfo.length; i++) {
      const date = new Date(state.customerUsersInfo[i].createdTime);
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      var d = date.getDate();
      d = d < 10 ? "0" + d : d;
      var h = date.getHours();
      h = h < 10 ? "0" + h : h;
      var min = date.getMinutes();
      min = min < 10 ? "0" + min : min;
      var s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      state.customerUsersInfo[i].createdTime =
        y + "-" + m + "-" + d + " " + h + ":" + min + ":" + s;
    }
    return state.customerUsersInfo || [];
  },
  customerDeviceFind(state) {
    if (state.customerDeviceFind.length) {
      const date = new Date(state.customerDeviceFind[0].createdTime);
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      var d = date.getDate();
      d = d < 10 ? "0" + d : d;
      var h = date.getHours();
      h = h < 10 ? "0" + h : h;
      var min = date.getMinutes();
      min = min < 10 ? "0" + min : min;
      var s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      state.customerDeviceFind[0].createdTime =
        y + "-" + m + "-" + d + " " + h + ":" + min + ":" + s;
    }
    return state.customerDeviceFind || [];
  },
};

export default {
  state,
  mutations,
  actions,
  getters,
};
